export default __webpack_public_path__ + "static/media/img-6.d8c2ee67.png";